import React, { useState } from 'react';
import T2MCheckpoint from './T2MCheckpoint';
import T2MRecords from './T2MRecords';
import T2MOverview from './T2MOverview';
import T2MTrialDetail from './T2MTrialDetail';
import T2MManager from './T2MManager';
import NewTrialModal from './NewTrialModal';

const TABS = ['Checkpoint', 'Manager', 'Records', 'Overview'];

export default function T2MModule() {
  const [tab, setTab]               = useState('Checkpoint');
  const [showNew, setShowNew]       = useState(false);

  // Support deep-link from Follow-Ups tab: /t2m?trialId=123
  const params = new URLSearchParams(window.location.search);
  const deepLinkId = params.get('trialId') ? parseInt(params.get('trialId')) : null;
  const [selectedId, setSelectedId] = useState(deepLinkId);

  if (selectedId) {
    return (
      <div className="module-page">
        <T2MTrialDetail trialId={selectedId} onBack={() => setSelectedId(null)} />
      </div>
    );
  }

  return (
    <div className="module-page">
      {showNew && <NewTrialModal onClose={() => setShowNew(false)} onCreated={(id) => { setShowNew(false); if (id) setSelectedId(id); }} />}

      {/* Header */}
      <div className="module-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span style={{ fontSize: 22 }}>🌱</span>
          <h1 className="module-title">Trial to Member</h1>
        </div>
        <button className="btn btn-primary btn-sm" onClick={() => setShowNew(true)}>+ New Trial</button>
      </div>

      {/* Tabs — always at top */}
      <div className="module-tabs">
        {TABS.map(t => (
          <button
            key={t}
            className={`module-tab ${tab === t ? 'active' : ''}`}
            onClick={() => setTab(t)}
          >
            {t}
          </button>
        ))}
      </div>

      {/* Content */}
      {tab === 'Checkpoint' && <T2MCheckpoint onSelectTrial={setSelectedId} />}
      {tab === 'Manager'    && <T2MManager />}
      {tab === 'Records'    && <T2MRecords onSelectTrial={setSelectedId} />}
      {tab === 'Overview'   && <T2MOverview />}
    </div>
  );
}
